// Application-wide constants
import { API_BASE_URL } from '../config';

// Re-export for backward compatibility with any existing code
export const API_URL = API_BASE_URL;

export const ROUTES = {
  LOGIN: '/login',
  SIGNUP: '/signup',
  PROFILE: '/profile',
  FEED: '/feed',
  MESSAGES: '/messages',
  JOBS: '/jobs',
  NETWORK: '/network',
  NOTIFICATIONS: '/notifications',
  SETTINGS: '/settings',
  COMPANIES: '/companies',
};

export const TAB_KEYS = {
  FEED: 'feed',
  MY_POSTS: 'my-posts',
  PROFILE: 'profile',
  PEOPLE: 'people',
  MESSAGES: 'messages',
  JOBS: 'jobs',
  COMPANIES: 'companies',
  NOTIFICATIONS: 'notifications',
  SETTINGS: 'settings',
};

export const SUBTAB_KEYS = {
  // People subtabs
  PEOPLE_CONNECTIONS: 'connections',
  PEOPLE_FOLLOWERS: 'followers',
  PEOPLE_FOLLOWING: 'following',
  PEOPLE_SUGGESTIONS: 'suggestions',

  // Messages subtabs
  MESSAGES_CONNECTION: 'connection',
  MESSAGES_OPEN: 'open',

  // Jobs subtabs
  JOBS_BROWSE: 'browse',
  JOBS_SAVED: 'saved-jobs',
  JOBS_APPLICATIONS: 'my-applications',
  JOBS_RESUME: 'resume',
  JOBS_FORMS: 'forms',
  JOBS_RECRUITER: 'recruiter',

  // Notifications subtabs
  NOTIFICATIONS_ALL: 'all',
  NOTIFICATIONS_UNREAD: 'unread',
};

export const WORK_MODES = {
  REMOTE: 'remote',
  HYBRID: 'hybrid',
  ONSITE: 'onsite',
};

export const APPLICATION_STATUS = {
  PENDING: 'pending',
  REVIEWED: 'reviewed',
  SHORTLISTED: 'shortlisted',
  INTERVIEW: 'interview',
  OFFERED: 'offered',
  REJECTED: 'rejected',
  WITHDRAWN: 'withdrawn',
};

export const POST_TYPES = {
  TEXT: 'text',
  IMAGE: 'image',
  VIDEO: 'video',
  SHARED: 'shared',
};

export const CONNECTION_STATUS = {
  NONE: 'none',
  PENDING: 'pending',
  CONNECTED: 'connected',
  FOLLOWING: 'following',
};
